var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import tick from "../helpers/async";
export var makePopupInstance = function (container) {
    var _private = {
        isOpen: false,
        isOpening: false,
        isClosing: false,
    };
    var s = {
        name: container.getAttribute('data-popup-name') || Math.random().toString(36).substr(2, 9),
        container: container,
        popup: container.querySelector('.popup'),
        get storageKey() {
            return "popup-".concat(s.name);
        },
        get isOpen() { return _private.isOpen; },
        set isOpen(v) { _private.isOpen = v; v ? s.container.classList.add('isOpen') : s.container.classList.remove('isOpen'); },
        get isOpening() { return _private.isOpening; },
        set isOpening(v) { _private.isOpening = v; v ? s.container.classList.add('isOpening') : s.container.classList.remove('isOpening'); },
        get isClosed() { return !_private.isOpen; },
        set isClosed(v) { _private.isOpen = !v; !v ? s.container.classList.add('isClosed') : s.container.classList.remove('isClosed'); },
        get isClosing() { return _private.isClosing; },
        set isClosing(v) { _private.isClosing = v; v ? s.container.classList.add('isClosing') : s.container.classList.remove('isClosing'); },
        open: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (s.isOpen)
                            return [2 /*return*/];
                        s.isOpen = true;
                        s.isOpening = true;
                        return [4 /*yield*/, tick(1000)];
                    case 1:
                        _a.sent();
                        s.isOpening = false;
                        return [2 /*return*/];
                }
            });
        }); },
        close: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (s.isClosed)
                            return [2 /*return*/];
                        s.isClosing = true;
                        return [4 /*yield*/, tick(380)];
                    case 1:
                        _a.sent();
                        s.isClosing = false;
                        s.isOpen = false;
                        return [2 /*return*/];
                }
            });
        }); },
        toggle: function () {
            if (s.isOpen)
                s.close();
            else
                s.open();
        },
        /** suppress auto popup */
        doNotShowAgain: function (options) {
            try {
                var storage = (options === null || options === void 0 ? void 0 : options.for) === 'this-session-only' ? sessionStorage : localStorage;
                storage.setItem(s.storageKey, 'suppressed');
            }
            catch (e) {
                console.error(e);
            }
        },
        init: function () { return __awaiter(void 0, void 0, void 0, function () {
            var backdrop, closeButton, storageState, autoOpenAfter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        backdrop = container.querySelector('.popup-backdrop');
                        closeButton = container.querySelector('.popup-close-button');
                        backdrop === null || backdrop === void 0 ? void 0 : backdrop.addEventListener('click', s.close);
                        closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', s.close);
                        storageState = localStorage.getItem(s.storageKey) || sessionStorage.getItem(s.storageKey);
                        if (storageState === 'suppressed')
                            return [2 /*return*/];
                        autoOpenAfter = container.getAttribute('data-auto-open-after');
                        if (!autoOpenAfter) return [3 /*break*/, 2];
                        return [4 /*yield*/, tick(+autoOpenAfter || 0)];
                    case 1:
                        _a.sent();
                        s.open();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }
    };
    s.init();
    return s;
};
export var PopupController = {
    init: function () {
        return new Promise(function (resolve, reject) {
            try {
                var popupSections = document.querySelectorAll('.popup-section');
                var instances_1 = Array.from(popupSections).map(function (sect) { return makePopupInstance(sect); });
                var POPUP_1 = window.PopupController = {
                    popups: {},
                    closeAll: function () { return instances_1.forEach(function (p) { return p.close(); }); },
                };
                instances_1.forEach(function (i) { return POPUP_1.popups[i.name] = i; });
                document.addEventListener('click', function (e) {
                    var _a, _b;
                    var popupName = (_a = e.target) === null || _a === void 0 ? void 0 : _a.getAttribute('data-popup-trigger');
                    if (popupName) {
                        (_b = POPUP_1.popups[popupName]) === null || _b === void 0 ? void 0 : _b.toggle();
                    }
                });
                resolve(POPUP_1);
            }
            catch (error) {
                reject(error);
            }
        });
    },
};
